package org.example.project.model

enum class Orientation {
    HORIZONTAL,
    VERTICAL
}